/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { isMessage } from '../../lib/utils';

import Pill from '../buttons/Pill';
import RoundedButton from '../buttons/Rounded';
import CircledPlusIcon from '../icons/CircledPlus';
import CloseIcon from '../icons/Cross';
import Link from './Link';

import styles from '../../../styles/partials/section-header.module.scss';

const propTypes = {
    className: PropTypes.string,
    title: PropTypes.node,
    description: PropTypes.node,
    buttonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    align: PropTypes.oneOf(['top', 'center', 'bottom']),
    url: PropTypes.string,
    isDark: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.bool,
};

const defaultProps = {
    className: null,
    title: null,
    description: null,
    url: null,
    buttonLabel: null,
    align: 'center',
    isDark: false,
    onClose: null,
    children: null,
};

const ListHeader = ({
    className,
    title,
    description,
    url,
    align,
    buttonLabel: initialButtonLabel,
    isDark,
    onClose,
    children,
}) => {
    const intl = useIntl();
    const buttonLabel =
        initialButtonLabel !== null
            ? initialButtonLabel
            : intl.formatMessage({
                  defaultMessage: 'See all sections',
                  description: 'Button label',
              });

    return (
        <header
            className={classNames([
                styles.container,
                styles[align],
                {
                    [className]: className !== null,
                    [styles.isDark]: isDark,
                    [styles.withCloseButton]: onClose !== null,
                },
            ])}
        >
            <div className={styles.content}>
                <div className={styles.main}>
                    <div className={styles.info}>
                        <h2 className={classNames([styles.title])}>
                            {url !== null ? (
                                <Link className={styles.titleLink} href={url}>
                                    {isMessage(title) ? intl.formatMessage(title) : title}
                                </Link>
                            ) : (
                                title
                            )}
                        </h2>
                        {description !== null ? (
                            <>
                                <div className={styles.separator}>
                                    <div className={styles.space} />
                                </div>
                                <div className={styles.description}>{description}</div>
                            </>
                        ) : null}
                    </div>
                    {children !== null ? <div className={styles.extra}>{children}</div> : null}
                </div>
                {url !== null ? (
                    <div className={styles.more}>
                        <RoundedButton className={styles.button} href={url}>
                            {buttonLabel}
                        </RoundedButton>

                        <Pill
                            className={styles.pill}
                            href={url}
                            icon={<CircledPlusIcon />}
                            title={buttonLabel}
                            isDark={isDark}
                        />
                    </div>
                ) : null}
            </div>
            {onClose !== null ? (
                <Pill
                    className={styles.closeBtn}
                    onClick={onClose}
                    icon={<CloseIcon />}
                    title={intl.formatMessage({
                        defaultMessage: 'Back',
                        description: 'Button label',
                    })}
                />
            ) : null}
        </header>
    );
};

ListHeader.propTypes = propTypes;
ListHeader.defaultProps = defaultProps;

export default ListHeader;
